import { apiClient } from './client';

export interface Invitation {
  id: string;
  token: string;
  url: string;
  platform: string;
  slug: string;
  displayName: string;
  status: string;
  expiresAt: string;
  consumedAt: string | null;
  tenantId: string | null;
  createdAt: string;
}

export interface CreateInvitationBody {
  platform: 'ganamos' | 'casinozeus' | 'kingbox' | 'soyjoker';
  slug: string;
  displayName: string;
  subdomain?: string;
  hgAccountId?: string | null;
}

export const invitationsApi = {
  list: async (): Promise<Invitation[]> => {
    const { data } = await apiClient.get('/admin/invitations');
    return data as Invitation[];
  },
  create: async (body: CreateInvitationBody): Promise<Invitation> => {
    const { data } = await apiClient.post('/admin/invitations', body);
    return data as Invitation;
  },
  revoke: async (id: string): Promise<void> => {
    await apiClient.delete(`/admin/invitations/${id}`);
  },
};
